import { showSetPasswordModal } from '../../actions/userActions';
import { hasCourses } from '../../utils/learningCourseUtils';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router';

const Navigation = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const sessionId = useSelector((state) => state.user.sessionId);
  const dashboardTiles = useSelector((state) => state.dashboard.tiles || []);
  const config = useSelector((state) => state.config.content);
  const userHasCourses = useSelector((state) => hasCourses(state.user.details));

  if (!sessionId) return null;

  let tiles = dashboardTiles.slice(0);

  if (config?.dashboard?.tileOrder) {
    tiles.sort((a, b) => {
      const order = config.dashboard.tileOrder;
      return order.indexOf(a.type) - order.indexOf(b.type);
    });

    tiles = tiles.map((tile) => ({
      ...tile,
      name: config.tiles?.[tile.type]?.title || tile.name,
    }));
  }

  const isCurrentLink = (link) => (link === location.pathname ? 'active' : '');

  return (
    <div className="navigation-secondary container d-print-none">
      <div className="row children">
        <div className="list-unstyled list-inline d-flex flex-wrap justify-content-between column-gap-3 row-gap-0 mb-3">
          <div className="d-block">
            <Link to="/" className={isCurrentLink('/')}>
              Dashboard
            </Link>
          </div>
          <div className="d-flex flex-wrap column-gap-3 me-2">
            <div className="d-block">
              <Link className="triggerSetPassword" to={location.pathname} onClick={() => dispatch(showSetPasswordModal(true))}>
                Change Password
              </Link>
            </div>
            <div className="d-block">
              <Link to="/logout">Log out</Link>
            </div>
          </div>
        </div>
        <ul className="col-sm-10 list-unstyled list-inline d-flex flex-wrap column-gap-3 row-gap-0">
          {tiles.map((tile) => {
            const url = (tile.subTiles ? '/sub/' : '/forms/') + tile.type;
            return (
              <li key={tile.type} className="d-block">
                <Link to={url} className={isCurrentLink(url)}>
                  {tile.name}
                </Link>
              </li>
            );
          })}
          {userHasCourses && (
            <li className="d-block">
              <Link to="/learning" className={isCurrentLink('/learning')}>
                Learning
              </Link>
            </li>
          )}
        </ul>
      </div>
    </div>
  );
};

export default Navigation;
